export const MFA_SEND = `/api/v1/user/mfa/send`;
export const MFA_VERIFY = `/api/v1/user/verify/mfa`;
